export const inspectTable = [
  {
    content: "작업환경측정(도급인의 작업환경측정 포함), 근로대자표 요구 시 참석, 결과 기록 등 (법 제125조)",
    isChecked: "",
  },
  {
    content: "일반건강진단 (법 제129조)",
    isChecked: "",
  },
  {
    content: "특수건강진단 등 (법 제130조)",
    isChecked: "",
  },
  {
    content: "임시건강진단 명령 등 (법 제131조)",
    isChecked: "",
  },
  {
    content: "건강진단에 관한 사업주의 의무 등 (법 제132조, 제133조)",
    isChecked: "",
  },
  {
    content: "유해·위험작업에 대한 근로시간 제한 등 (법 제139조)",
    isChecked: "",
  },
  {
    content: "자격 등에 의한 취업 제한 등 (법 제140조)",
    isChecked: "",
  },
  {
    content: "고객의 폭언 등으로 인한 건강장해 예방조치 (법 제41조)",
    isChecked: "",
  },
];
